import { render } from "./pdfPrintButton.vue?vue&type=template&id=04252270"
import script from "./pdfPrintButton.vue?vue&type=script&lang=js"
export * from "./pdfPrintButton.vue?vue&type=script&lang=js"

import "./pdfPrintButton.vue?vue&type=style&index=0&id=04252270&lang=scss"

import exportComponent from "/Users/jeromebart/sites/cdm-quiz/cite-des-metiers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__